"use strict";

/**
 * @function
 * @description handles Newsletter Section
 */
const handleNewsletterSection = () => {
    const $newsletterSection = $(".c-newsletter");
    const $newsletterSectionContainer = $(".c-newsletter-container");

    if ($newsletterSection.find(".c-newsletter-subscription").length < 1) {
        $newsletterSection.remove();

        if ($newsletterSectionContainer.length) {
            $newsletterSectionContainer.remove();
        }
    }
};


module.exports = handleNewsletterSection;
